/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerFormMessages.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Form Messages
 *  
 *  Author:     Norman J. Nolasco [ Archetact ]
 *
 *  Created:    Saturday, August 27, 2022 - 09:05:11 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      08/27/2022  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2022 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    FORMMESSAGE_LIST_CONTAINER_LOADED,
    FORMMESSAGE_LIST_CONTAINER_UNLOADED,
    FORMMESSAGE_LIST_TABLE_LOADED,
    FORMMESSAGE_LIST_TABLE_UNLOADED,

    FORMMESSAGE_SELECT_ROW,
    FORMMESSAGE_ADD,
    FORMMESSAGE_EDIT,
    FORMMESSAGE_DELETE,
    FORMMESSAGE_OPEN_WARNING,
    FORMMESSAGE_CLOSE_WARNING,
    FORMMESSAGE_DELETE_DISABLE,

    FORMMESSAGE_EDIT_CONTAINER_LOADED,
    FORMMESSAGE_EDIT_CONTAINER_UNLOADED,
    FORMMESSAGE_EDIT_FORM_LOADED,
    FORMMESSAGE_EDIT_FORM_UNLOADED,
    FORMMESSAGE_EDIT_DATA_LOAD,
    FORMMESSAGE_EDIT_CONTAINER_SUBMIT,
    FORMMESSAGE_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeFormMessages';

const defaultState = {
    refreshList: false,
    danger: false,
    formmessageid: 0,
    fromemail: '',
    toemail: '',
    fullname: '',
    firstname: '',
    lastname: '',
    sourceform: '',
    subject: '',
    message: '',
    readflag: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case FORMMESSAGE_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                formmessages: action.payload[0] ? action.payload[0].records : null
            }
        case FORMMESSAGE_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case FORMMESSAGE_SELECT_ROW:
            return {
                ...state,
                formmessageid: action.id
            }
        case FORMMESSAGE_ADD:
            return {
                ...state
            }
        case FORMMESSAGE_EDIT:
            return {
                ...state,
                formmessageid: action.id
            }
        case FORMMESSAGE_DELETE:
            return {
                ...state,
                formmessageid: null
            }
        case FORMMESSAGE_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case FORMMESSAGE_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case FORMMESSAGE_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case FORMMESSAGE_EDIT_CONTAINER_LOADED:
        case FORMMESSAGE_EDIT_DATA_LOAD:
            return {
                ...state,
                formmessageid: action.payload[0] ? action.payload[0].formmessageid : 0,
                fromemail: action.payload[0] ? action.payload[0].fromemail : '',
                toemail: action.payload[0] ? action.payload[0].toemail : '',
                fullname: action.payload[0] ? action.payload[0].fullname : '',
                firstname: action.payload[0] ? action.payload[0].firstname : '',
                lastname: action.payload[0] ? action.payload[0].lastname : '',
                sourceform: action.payload[0] ? action.payload[0].sourceform : '',
                subject: action.payload[0] ? action.payload[0].subject : '',
                message: action.payload[0] ? action.payload[0].message : '',
                readflag: action.payload[0] ? action.payload[0].readflag : 0,
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case FORMMESSAGE_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case FORMMESSAGE_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case FORMMESSAGE_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case FORMMESSAGE_LIST_CONTAINER_UNLOADED:
        case FORMMESSAGE_LIST_TABLE_UNLOADED:
        case FORMMESSAGE_EDIT_CONTAINER_UNLOADED:
        case FORMMESSAGE_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};
